import { render, staticRenderFns } from "./new-product.vue?vue&type=template&id=2e5a51c2"
import script from "./new-product.vue?vue&type=script&lang=js"
export * from "./new-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5a51c2')) {
      api.createRecord('2e5a51c2', component.options)
    } else {
      api.reload('2e5a51c2', component.options)
    }
    module.hot.accept("./new-product.vue?vue&type=template&id=2e5a51c2", function () {
      api.rerender('2e5a51c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/new-product.vue"
export default component.exports